import React from "react";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton, ModalSecondaryButton } from "../..";
import { useParams, useRoute, useModel, BCMSRecord, useBCMSContext, ModalClose } from "@bcm-dev/bcms-vite";

import Classes, { Card } from "model";
import "./styles.css";

/**
 * @function TurnCardOffModal
 * @return {React.Component}
 * @exported true
 * @description The main component for TurnCardOffModal
 */
export default function TurnCardOffModal(props) {
  const { branding } = useModel();
  const controller = useBCMSContext();
  const navigate = useRoute();

  const { route } = props.data;
  const defaultCard = branding.options.include_debit_chw23 !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const card = Card.initByID(cardID);

  const cardType = card.type ?? "[Card Type]";
  const lastFour = card.lastFour ?? "XXXX";

  const lostStolenRoute = evt => {
    BCMSRecord.batch([
      Card.update({ ...card.record, isOn : false })
    ], controller, Classes);

    navigate(route);
  };

  return (
    <CustomModal className="turn-card-off-modal" id="TurnCardOffModal" title="Turn Card OFF">
      <CustomModalContent>
        <p className="text-center">We will turn OFF your { cardType } ending in { lastFour } to prevent further fraud. </p>
      </CustomModalContent>
      <CustomModalFooter>
        <ModalPrimaryButton text="Continue" onClick={ lostStolenRoute } close={ true } id="TurnCardOffModal" />
        <ModalClose id="TurnCardOffModal">
            <ModalSecondaryButton text="Cancel" />
          </ModalClose>
      </CustomModalFooter>
    </CustomModal>
  );
}